"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.precise = void 0;
function precise(source, precision) {
    if (precision === void 0) { precision = 12; }
    return parseFloat(source.toPrecision(precision));
}
exports.precise = precise;
